<template>
  <div class="main-container">
    <div class="block-container">
      <div class="board">
        <div class="page page-resultados padding-lr">
          <div class="search-term" style="text-decoration: underline;">{{ tag }}</div>
        </div>
        <section class="section padding-b" v-if="page.content.length > 0">
          <template v-for="(elem,index) in page.content" :key="index">
            <article-two :news="item(index)"></article-two>
          </template>
        </section>

        <div class="block-container" v-if="true === error || (started && 0 === news.length)">
          <div class="board-404">
            <h2>No se encontraron más noticias relacionadas con {{ tag }}</h2>
            <p>Te invitamos a seguir navegando <a href="/">iProUP</a>.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Admin        from '@core/vuejs/templates/admin/mixins/_Admin'
import _Page         from "@core/vuejs/templates/mixins/_Page"

export default {
  name: "SectionByTagPage",
  mixins: [Admin, _Page],
  data: function() {
    return {
      name: ''
    };
  },
  serverPrefetch() {
    // Aqui debemos implementar la consulta a la API
  },
  computed: {
    page: function () {
      return this.$store.getters["section/page"];
    },
    tag: function()
    {
      let tag = ''
      if("undefined" != typeof window) tag = window.location.pathname.substring(1).replace(/-/g, ' ')
      return tag.charAt(0).toUpperCase() + tag.slice(1);
    }
  },
  methods: {
    item: function(index){
      return this.page.content[index];
    }
  }
}
</script>